<section>
  <div class="container">
      <div class="board">
          <!-- Navigation Area (Circular Tabs) -->
          
          <!-- End Navigation Area (Circular Tabs) -->
          <!-- Content Area -->
          <div class="tab-content">
              <!-- Nested view  -->
              <router-outlet></router-outlet>
          </div>
          
          <!-- End Content Area -->
      </div>

      <!-- <pre>{{formData | json }}</pre> -->
   </div>
</section>